// src/config.ts
// Default to the local tenant-api port (see apps/tenant-api/src/main.ts).
// Override with VITE_API_URL in apps/tenant-frontend/.env.local.
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";
export const ENV = import.meta.env.VITE_APP_ENV || "development";

// Environment-specific settings
export const isDevelopment = ENV === "development";
export const isProduction = ENV === "production";

export default {
  API_URL,
  ENV,
  isDevelopment,
  isProduction,
};
